import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './pill.scss';

const cx = classnames.bind(styles);

const Pill = ({ text, icon, theme }) => {
  const themes = {
    primary: 'pill__primary',
    success: 'pill__success',
    danger: 'pill__danger',
  };

  return (
    <div className={cx('pill', [themes[theme]])}>
      {icon && <span className={cx('pill_icon')}>{icon}</span>}
      {text}
    </div>
  );
};

Pill.defaultProps = {
  icon: null,
  text: null,
  theme: null,
};

Pill.propTypes = {
  icon: PropTypes.element,
  text: PropTypes.string,
  theme: PropTypes.oneOf([null, 'primary', 'success', 'danger']),
};

export default Pill;
